var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-actions',[_c('v-card-title',{staticClass:"text_box"},_vm._l((_vm.getProjectUsers),function(user){return _c('div',{key:user.id},[_c('v-chip',{attrs:{"color":"primary","close":""},on:{"click:close":function($event){return _vm.deleteUser(user)}}},[_vm._v(" "+_vm._s(user.member_name)+" ")])],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }